import styled from "styled-components";

export const Container = styled.footer`
  background: #143774;
  color: white;
  text-align: center;
  padding: 3em 0;
`;
